import { render, staticRenderFns } from "./AccountingRule.vue?vue&type=template&id=0aa9131c&"
import script from "./AccountingRule.vue?vue&type=script&lang=js&"
export * from "./AccountingRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports